export default {
  nav: {
    home: 'Home',
    video: 'Videosorveglianza',
    alarm: 'Sistemi di Allarme',
    solutions: 'Soluzioni',
    care: 'SSG Care',
    planner: 'Planner Telecamere',
    areas: 'Zone di Servizio',
    about: 'Chi Siamo',
    contact: 'Contatti',
  },
  dropdown: {
    allSolutions: 'Vedi tutte le soluzioni',
    homeGrounds: 'Casa e Proprietà',
    retailGastro: 'Commercio e Ristorazione',
    officePractice: 'Ufficio e Studio',
    warehouseLogistics: 'Magazzino e Logistica',
    workshopTrade: 'Officina e Commercio',
    apartments: 'Condomini e Immobili',
    cameraTypes: 'Tipi di Telecamere',
    services: 'Servizi',
    technology: 'Tecnologia',
  },
  footer: {
    brandLine: 'Tecnologia di sicurezza per privati e aziende',
    area: 'Hainburg · Regione Reno-Meno',
    services: 'Servizi',
    solutions: 'Soluzioni',
    forWhom: 'Per Chi',
    contact: 'Contatti',
    areaLabel: 'Zona di servizio Reno-Meno',
    privateCustomers: 'Clienti privati',
    businessCustomers: 'Clienti aziendali',
    allSolutions: 'Tutte le soluzioni',
    faq: 'Domande frequenti',
    rights: 'Tutti i diritti riservati.',
    impressum: 'Note legali',
    privacy: 'Informativa sulla privacy',
    cookieSettings: 'Impostazioni cookie',
  },
  related: {
    eyebrow: 'Altre soluzioni',
    title: 'Scopri altri tipi di immobile',
    viewAll: 'Vedi tutte le soluzioni',
  },
};